<footer class="footer">
   <div class="w-100 clearfix">
      <span class="text-muted d-block text-center text-sm-left d-sm-inline-block">Copyright © 2020 <a href="www.irisgst.com" target="_blank" class="iris-gst-link">irisgst.com</a>. All rights reserved.</span>          
      <span class="iris-gst-pull-right" *ngIf="isShow" (click)="gotoTop()" class="toTopBtn"><i class="mdi mdi-arrow-up-bold-hexagon-outline"></i></span> 
   </div>
</footer>